import { Module } from 'vuex';
import { getters } from './getters';
import { actions as indexActions } from './actions';
import { actions as pathActions } from './paths/actions';
import { actions as statesActions } from './states/actions';
import { mutations as indexMutations } from './mutations';
import { mutations as pathMutations } from './paths/mutations';
import { mutations as stateMutations } from './states/mutations';
import { mutations as triggerMutations } from './triggers/mutations';
import { AppState } from '../app';
import { ChangeType, FlowViewModel, InputVariableViewModel } from '@/features/bots/models/designer';
import { FlowListItemViewModel } from '@/features/bots/models/flowListItemViewModel';
import { FlowStatus } from '@/features/bots/models/flowStatus';

export interface FlowDesignerState {
  currentFlow: FlowViewModel;
  currentPathId: string;
  flowVariables: InputVariableViewModel[];
  changes: { [key: string]: boolean };
  isSaveFlowInProgress: boolean;
  flows: FlowListItemViewModel[];
}

// initial state
export const flowDesignerState: FlowDesignerState = {
  currentFlow: {
    id: '',
    name: '',
    status: FlowStatus.Draft,
    paths: [],
    triggers: [],
    businessHours: [],
    targetContactTypes: [],
    parentAnswers: [],
    parentFlows: [],
  },
  currentPathId: '',
  flowVariables: [],
  changes: {
    [ChangeType.Name]: false,
    [ChangeType.Paths]: false,
    [ChangeType.Triggers]: false,
  },
  isSaveFlowInProgress: false,
  flows: [],
};

const actions = Object.assign({}, indexActions, pathActions, statesActions);
const mutations = Object.assign({}, indexMutations, pathMutations, stateMutations, triggerMutations);
export const flowDesigner: Module<FlowDesignerState, AppState> = {
  namespaced: false,
  state: flowDesignerState,
  getters,
  actions,
  mutations,
};
